import { useEffect, useState } from "react";
import { Play } from "lucide-react";

const slides = [
  {
    img: "/m1.jpg",
    title: "HEART EYES",
    rating: "R18",
    language: "ENGLISH",
    genre: "COMEDY, HORROR, MYSTERY",
    duration: "90 MIN",
  },
  {
    img: "/m2.jpg",
    title: "THUNDERBOLTS*",
    rating: "PG12",
    language: "ENGLISH",
    genre: "ACTION, ADVENTURE",
    duration: "126 MIN",
  },
  {
    img: "/m3.jpg",
    title: "Siko Siko (Egyptian) - Arabic*",
    rating: "PG12",
    language: "ARABIC",
    genre: "COMEDY, ADVENTURE",
    duration: "121 MIN",
  },
  {
    img: "/m4.jpg",
    title: "The Legend of Ochi*",
    rating: "PG12",
    language: "ENGLISH",
    genre: "ADVENTURE, FAMILY, FANTASY",
    duration: "95 MIN",
  },
  {
    img: "/m5.jpg",
    title: "Shadow Force*",
    rating: "PG12",
    language: "ENGLISH",
    genre: "ACTION",
    duration: "104 MIN",
  },
];

const HeroSlider = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const current = slides[index];

  return (
    <div className="relative w-full mt-8  md:h-[80lvh]  h-[50lvh] overflow-hidden">
      {/* Backgrounds */}
      {slides.map((s, i) => (
        <div
          key={i}
          className={`absolute top-0 left-0 w-full bg-cover  h-full  bg-center transition-opacity duration-1000 ${
            i === index ? "opacity-100 z-10" : "opacity-0 z-0"
          }`}
          style={{ backgroundImage: `url(${s.img})` }}
        />
      ))}

      {/* Overlay Content */}
      <div className="absolute bottom-6 sm:bottom-12 left-4 sm:left-12 z-20 text-white w-[90%] sm:max-w-full transition-opacity duration-700">
        <div className="flex flex-wrap items-center gap-2 sm:gap-3">
          <h1 className="text-2xl sm:text-5xl font-semibold uppercase">{current.title}</h1>
          <span className="px-2 py-1 text-xs sm:text-sm font-bold bg-orange-500 rounded">
            {current.rating}
          </span>
        </div>

        <div className="flex flex-wrap items-center mt-3 sm:mt-4 gap-x-3 gap-y-2 text-xs md:text-sm font-semibold text-gray-200">
          <span>{current.language}</span>
          <span className="text-gray-500">|</span>
          <span>{current.genre}</span>
          <span className="text-gray-500">|</span>
          <span>{current.duration}</span>
          <span className="text-gray-500">|</span>
          <button className="flex items-center gap-1 hover:underline">
            <Play className="w-4 h-4" />
            WATCH TRAILER
          </button>
          <button className="px-4 py-2 font-semibold text-white bg-red-600 rounded hover:bg-red-700">
            Book Now
          </button>
        </div>
      </div>

      {/* Dots */}
      <div className="absolute right-3 sm:right-6 top-1/2 transform -translate-y-1/2 z-20 flex flex-col gap-2">
        {slides.map((_, i) => (
          <div
            key={i}
            className={`w-2.5 h-2.5 rounded-full border ${
              i === index ? "bg-white" : "border-gray-500"
            }`}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;
